// extracted by mini-css-extract-plugin
module.exports = {"row":"rules_row__1cvxv","col":"rules_col__1LP3J","ueberschrift":"rules_ueberschrift__1jHO7","col1":"rules_col1__2Isy9","pad15":"rules_pad15__3E6Gt","img":"rules_img__19AVr"};